import { UserAppRole, UserOrganizationRole } from '../models/graphql';
import { useSelectedOrganization } from './useSelectedOrganization';
import { useUserData } from './useUserData';
import { useContext, useMemo } from 'react';
import { AppContext } from '../providers/AppProvider';

export type Role = {
  appRole: UserAppRole;
  selectedOrgRole: null | UserOrganizationRole;
};

export const useUserRole = (): Role => {
  const { selectedWorkspaceId } = useContext(AppContext);
  const { selectedOrganization } = useSelectedOrganization();
  const { userData } = useUserData();

  return useMemo(() => {
    let selectedOrgRole: Role['selectedOrgRole'] = null;
    let appRole: Role['appRole'] = UserAppRole.USER;

    if (selectedWorkspaceId && userData && selectedOrganization && selectedOrganization.myUserAssignment) {
      appRole = userData.appRole;
      selectedOrgRole = selectedOrganization.myUserAssignment.role;
    }
    return {
      appRole,
      selectedOrgRole
    };
  }, [selectedOrganization, userData, selectedWorkspaceId]);
};
